import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue';
import VueMarkdown from 'vue-markdown';
import { useOpenLinkNewTab } from '@/composables';


const __default__ = {
  name: 'About',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  data: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {



const { setTargetAttributeToLink } = useOpenLinkNewTab();

onMounted(() => {
  setTargetAttributeToLink(['sub-title', 'description']);
});

return { __sfc: true,setTargetAttributeToLink, VueMarkdown }
}

})